import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import App from './App';
import './index.css';
import { initConsoleReporting } from '@/utils/logger';

initConsoleReporting();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const publishableKey =
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ||
  'pk_test_ZGVjZW50LWJsdWVnaWxsLTk1LmNsZXJrLmFjY291bnRzLmRldiQ';

if (!publishableKey) {
  console.error('VITE_CLERK_PUBLISHABLE_KEY is not set');
}

createRoot(rootElement).render(
  <StrictMode>
    <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/">
      <App />
    </ClerkProvider>
  </StrictMode>
);

